<template>
  <Modal
    :modal="modal"
    title="Tabela de Preço"
    cardBodyClass="pa-0"
    @close="$emit('close')"
    @save="$emit('save', tabelaPrecoSelected)"
    @refresh="getTabelasPrecoAPI"
    @search="searchBox = !searchBox"
    :loading="loading"
    :fullscreen="true"
    :titleIcons="titleIcons"
  >
    <ListTabelasPrecoSelect
      :searchBox="searchBox"
      @tabelaPrecoSelected="selectTabelaPreco"
    />
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/shared/Modal';
import ListTabelasPrecoSelect from '@/components/tabelasPreco/ListTabelasPrecoSelect';

export default {
  name: 'ModalTabelaPreco',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Modal,
    ListTabelasPrecoSelect
  },
  data: () => ({
    loading: false,
    searchBox: false,
    tabelaPrecoSelected: null,
  }),
  computed: {
    ...mapGetters(['tabelasPreco']),
    titleIcons() {
      return [
        { name: 'mdi-refresh', event: 'refresh', loading: true },
        { name: this.searchBox ? 'mdi-close' : 'mdi-magnify', event: 'search', loading: false },
      ]
    }
  },
  methods: {
    ...mapActions(['fetchTabelasPreco', 'fetchTabelasPrecoAPI']),
    tabelaPrecoJaSelecionada(id_tabela_preco) {
      return this.tabelaPrecoSelected && this.tabelaPrecoSelected.id_tabela_preco == id_tabela_preco;
    },
    selectTabelaPreco(tabelaPreco) {
      if (this.tabelaPrecoJaSelecionada(tabelaPreco.id_tabela_preco)) return this.tabelaPrecoSelected = null;
      this.tabelaPrecoSelected = tabelaPreco;
    },
    getTabelasPreco() {
      this.loading = true;
        this.fetchTabelasPreco()
          .then(() => this.loading = false);
    },
    getTabelasPrecoAPI() {
      this.loading = true;
        this.fetchTabelasPrecoAPI()
          .then(() => {
            this.tabelaPrecoSelected = null;
            this.loading = false;
          });
    }
  },
  watch: {
    modal(value) {
      if (value && !this.tabelasPreco.length && !this.loading) {
        this.getTabelasPreco();
      }
    }
  },
}
</script>

<style>

</style>